import { Box, type BoxProps } from '@mui/material';
import type { ReactNode } from 'react';
import type { CommonProps } from '../types';

export type CustomizedSummaryDetailsProps = CommonProps & {
  variant: 'customizedSummary';
  CollapseDetailsComponent: ReactNode;
  collapseDetailsParentProps?: Partial<BoxProps> & { ['data-testid']?: string };
  ExpandDetailsComponent: ReactNode;
  expandDetailsParentProps?: Partial<BoxProps> & { ['data-testid']?: string };
};

export function CustomizedSummaryDetails({
  children,
  CollapseDetailsComponent,
  collapseDetailsParentProps = {},
  detailsProps = {},
  ExpandDetailsComponent,
  expandDetailsParentProps,
  summaryComponentProps = {},
}: CustomizedSummaryDetailsProps) {
  const { sx: sxDetailsProps, ...restDetailsProps } = detailsProps;
  const { sx: sxCollapseDetailsParentProps, ...restCollapseDetailsParentProps } =
    collapseDetailsParentProps;
  const { sx: sxSummaryComponentProps, ...restSummaryComponentProps } = summaryComponentProps;
  return (
    <Box
      sx={{
        position: 'relative',
        '&[open] > summary > .open-summary': {
          display: 'none',
        },
        '&[open] > summary > .close-summary': {
          display: 'flex',
        },
        ...sxDetailsProps,
      }}
      component="details"
      {...restDetailsProps}
    >
      <Box
        component="summary"
        data-testid="detail-summary"
        sx={{
          listStyle: 'none',
          listStyleType: 'none',
          '::-webkit-details-marker': {
            display: 'none',
          },
          '::marker': {
            display: 'none',
          },
          cursor: 'pointer',
          ...sxSummaryComponentProps,
        }}
        {...restSummaryComponentProps}
      >
        <Box component="span" className="open-summary" {...expandDetailsParentProps}>
          {ExpandDetailsComponent}
        </Box>
        <Box
          component="span"
          className="close-summary"
          sx={{
            display: 'none',
            ...sxCollapseDetailsParentProps,
          }}
          {...restCollapseDetailsParentProps}
        >
          {CollapseDetailsComponent}
        </Box>
      </Box>
      {children}
    </Box>
  );
}
